import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { Metrics, Colors, Fonts } from '../../Themes'

const Card = styled.div`
  width: 100%;
  backgroundColor: ${Colors.white};
`

const CardHeader = styled.div`
  width: 100%;
  height: 40px;
  padding: 0 ${Metrics.components.cardContainerSpacing};
  backgroundColor: ${Colors.black};
  color: ${Colors.white};
`

const Title = styled.div`
  ${Fonts.style.Text};
  text-transform: uppercase;
  color: ${Colors.white};
  padding: 13px 0;
`

const CardContent = styled.div`
  width: 100%;
  padding: ${Metrics.margins.large};
  max-height: calc(100% - 40px);
  overflow-y: scroll;
`

const CardContainer = props => {
  const { children, title, className, id } = props

  return (
    <Card className={className} id={id}>
      <CardHeader>
        <Title>{title}</Title>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  )
}

CardContainer.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string
}

export default CardContainer



// WEBPACK FOOTER //
// ./src/components/CardContainer/index.js